import React from 'react'

import { LOCALES } from '@elo-kit/constants/locales.constants'
import { EloMonduDeIcon } from '@elo-ui/components/icons/payment-methods/mondu-de-icon'
import { EloMonduEnIcon } from '@elo-ui/components/icons/payment-methods/mondu-en-icon'
import type { EloIconProps } from '@elo-ui/components/icons/payment-methods/types'
import MonduDe from 'shared/components/purchase-methods/assets/paymethods/MonduDe.svg'
import MonduEn from 'shared/components/purchase-methods/assets/paymethods/MonduEn.svg'

const isGermanLocale = (locale?: string) => locale === LOCALES.de

export const getLocalisedMonduIcon = (locale: string | undefined, props: EloIconProps) =>
  isGermanLocale(locale) ? <EloMonduDeIcon {...props} /> : <EloMonduEnIcon {...props} />

export const getLocalisedMonduLogo = (locale?: string) => (isGermanLocale(locale) ? MonduDe : MonduEn)
